/**
 * @date:2021.02.01
 * 开发环境development：复制此文件重命名为.env.dev.js
 * 正式环境production：复制此文件重命名为.env.prod.js
 */
let base_api_url = 'https://deapitest.yichuanghub.com/api'
const UNI_APP = {
    BASE_API: base_api_url.lastIndexOf('/') == base_api_url.length - 1 ? base_api_url.slice(0, base_api_url.lastIndexOf('/')) : base_api_url,
    WS_HOST:'chatdesignerwstest.yichuanghub.com:31521',
    WS_API: 'https://chatdesignertest.yichuanghub.com/'
}

module.exports = UNI_APP;
